import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { WorkScopeOption } from "./types";
import { v4 as uuidv4 } from 'uuid'

@Component({
  selector: 'app-edit-option-dialog',
  templateUrl: './edit-option-dialog.component.html'
})
export class EditOptionDialogComponent {
  form = new FormGroup({
    name: new FormControl<string>(null, [Validators.required]),
    description: new FormControl<string>(null, [Validators.required])
  })

  constructor(
    private dialogRef: MatDialogRef<EditOptionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      option: WorkScopeOption
    }
  ) {
    if (data?.option) {
      this.form.patchValue({
        name: data.option.name,
        description: data.option.description
      })
    }
  }

  onSave() {
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach(controlName => {
        if (this.form.controls[controlName].invalid) {
          console.log(controlName)
          this.form.controls[controlName].markAsTouched()
        }
      })
      return;
    }
    if (this.data?.option) {
      const option: WorkScopeOption = {
        ...this.data.option,
        name: this.form.controls.name.value,
        description: this.form.controls.description.value
      }
      this.dialogRef.close(option)
      return;
    }
    const option: WorkScopeOption = {
      id:  uuidv4(),
      isSystem: false,
      defaultName: this.form.controls.name.value,
      defaultDescription: this.form.controls.description.value,
      name: this.form.controls.name.value,
      description: this.form.controls.description.value
    }
    this.dialogRef.close(option)
  }

  onClose() {
    this.dialogRef.close()
  }
}